<template>
  <div>
    <h5><b>Termos de uso</b></h5>
    <p>
          O objetivo deste termo é esclarecer os direitos e obrigações do fornecedor e do usuário do Sistema. Ao criar uma conta, você se torna um USUÁRIO, logo aceita e concorda em cumprir os requisitos que estão estabelecidos neste TERMO DE USO.
        </p>
        <h5><b>Sobre o sistema</b></h5>
        <p>
          Trata-se de software proprietário que atende as necessidades de modernização da gestão no monitoramento e avaliação das Ações e Serviços de Saúde ofertados nas unidades de saúde da Atenção Primária à Saúde (APS) do Brasil, inclusive para acompanhar a Capitação Ponderada, Ações Estratégicas e Pagamentos por Desempenho, os quais fazem parte o Programa Previne Brasil. O uso deste sistema não acarreta ônus para os profissionais de saúde, mas é necessário que a licença seja adquirida pela Secretaria Municipal de Saúde onde o profissional está atuando. Somente com a aquisição da licença municipal, os profissionais de saúde podem fazer uso das funcionalidades disponíveis.
        </p>
        <p>
          Enquanto ferramenta de inteligência de negócio e visualização de dados em saúde, esse sistema auxilia, entre outras coisas, nas ações de:
        </p>
        <p>
          <ul>
              <li>Monitoramento dos cadastros individuais por Agente Comunitário de Saúde;</li>
              <li>
                  Acompanhamento das pessoas visitadas por Agente Comunitário de Saúde;
              </li>
              <li>
                Monitoramento e avaliação dos resultados dos indicadores de desempenho da APS estratificado por município, equipe e microárea
              </li>
              <li>
                  Monitoramento dos atendimentos no âmbito do Informatiza APS;
              </li>
              <li>
                  Monitoramento e avaliação das ações de saúde no território;
              </li>
              <li>
                  Disponibilização de um painel de gestão que pode ser acessado pelas principais tecnologias (computador, smartphone/iphone) utilizando o sistema operacional Linux, Windows, MAC OS, IOS ou android com navegador de internet atualizado;
              </li>
              <li>
                  Identificação dos cadastros duplicados de cidadãos;
              </li>
              <li>Identificação de cidadãos não vinculados às equipes de APS;</li>
              <li>Identificação de cidadãos não vinculados aos Agentes Comunitários de Saúde;</li>
              <li>Identificação de cidadão com Cartão Nacional de Saúde inválidos;</li>
              <li>Monitoramento de envio de dados do aplicativo do Agente Comunitário de Saúde para o sistema e-SUS PEC;</li>
              <li>Validação dos profissionais de saúde entre o e-SUS PEC e o SCNES para que os dados sejam enviados com sucesso para o sistema SISAB;</li>
              <li>Identificação de cidadãos que estão com vacinas atrasadas;</li>
              <li>Acompanhamento dos atendimentos dos profissionais por data e turno nos últimos 30 dias;</li>
              <li>Capacidade para mediar a busca ativa em relação aos diversos tipos de serviços disponíveis na APS e filtrado por equipe e microárea.</li>
          </ul>
      </p>
        <p>
            <h5><b>Acesso ao sistema</b></h5>
        </p>
        <p>
            O acesso é permitido por meio de LOGIN e SENHA, credenciais cadastradas pelo USUÁRIO. Estas são de uso pessoal e intransferível, logo o USUÁRIO deve tomar todas as medidas necessárias para mantê-las em sigilo. Os dados coletados para gerar as credenciais do USUÁRIO não são utilizados para outra finalidade se não a de acessar o sistema.
        </p>
        <p>
            Cada USUÁRIO tem acesso apenas aos dados dos cidadãos que estão sob seus cuidados, ou seja, os profissionais das equipes têm acesso aos dados de cidadãos vinculados apenas aquela equipe, os Agentes Comunitários de Saúde têm acesso aos cidadãos vinculados apenas aquela microárea.
        </p>
        <p>
          Para manter o usuário e os dados dos cidadãos sempre mais seguros, nós vamos recomendar a leitura e aceite dos termos de uso, bem como a atualização das informações de credenciais do usuário com o objetivo de confirmar constantemente a identidade dos profissionais de saúde e gestores que acessam a plataforma. O objetivo é oferecermos um ambiente de Monitoramento, Avaliação e Busca Ativa sempre mais seguro.
        </p>
        <p>
            <h5><b>Proteção dos dados</b></h5>
        </p>
        <p>
            O Sistema facilita a tomada de decisão entre os profissionais de saúde da mesma equipe e/ou unidade de saúde da APS, bem como os gestores locais de saúde, por meio do compartilhando de informações. Para isso, é necessário que o USUÁRIO aceite este TERMO. Os cidadãos atendidos nas unidades de saúde têm seus dados (nome, data de nascimento, CPF, CNS, nome da mãe, contato e atendimentos consolidados) compartilhados dentro do serviço de Atenção Primária do município, alinhado ao modelo de atenção preconizado. Caso o cidadão opte por não compartilhar os seus dados de atendimento, eles não serão compartilhados com os profissionais de saúde ou gestores locais de saúde.
        </p>
        <p>
            Não são compartilhadas informações sobre condições de saúde que possam gerar discriminação do cidadão.
        </p>
        <p>
           O Sistema respeita a privacidade e confidencialidade dos dados dos cidadãos, profissionais de saúde, gestores e cidadãos nos termos da Lei Geral de Proteção de Dados, da Constituição Federal, do Código Penal e das normas brasileiras aplicáveis. Recomenda-se que o USUÁRIO do sistema, tenha todos os cuidados necessários para proteger os dados que estão sendo visualizados e/ou acessados, bem como sua privacidade e confidencialidade.
        </p>
        <p>
          As lista com os nomes e dados de identificação dos cidadãos sob responsabilidade das equipes de saúde e a gestão municipal estão protegidas pela Lei Geral de Proteção de Dados (LGPD, Lei nº 13.709/2018). O uso destas informações para outros fins que não seja o Monitoramento, Avaliação e a Busca Ativa na APS municipal se caracteriza como uso ou divulgação indevidos dos dados dos cidadãos e poderá acarretar em penalidades para o usuário que praticar tal ato. Como o acesso aos dados do cidadão são permitidos apenas para os usuários cadastrados e liberados pelo gestor municipal, nós armazenamos a trilha de acesso do usuário para a tender a necessidades legais, caso ocorram.
        </p>
        <p>
            <h5><b>Infraestrutura tecnológica</b></h5>
        </p>
        <p>
          A responsabilidade pelos equipamentos ou dispositivos adequados a utilização do sistema é do USUÁRIO, pois é necessário que sejam atendidos os requisitos mínimos (computador, smartphone com android ou iphone, todos com navegador de internet atualizado e acesso à internet) para uso do Sistema. Não nos cabe a responsabilização pelo funcionamento ou desempenho inadequados do sistema, caso as configurações recomendadas não sejam atendidas.
        </p>
        <p>
          <h5><b>Responsabilidade do usuário do sistema</b></h5>
          Ao entrar no sistema com suas credenciais, todos os dados que estão sendo visualizados são de responsabilidade do USUÁRIO que deve:
        </p>
        <p>
          <ul>
              <li>Realizar a guarda, proteção dos dados seguindo as disposições da Lei nº 13.709/2018;</li>
              <li>Não disponibilizar ou permitir a outras pessoas ou instituições a suas credenciais para visualizar os dados com seu acesso;</li>
              <li>Acessar o sistema apenas para finalidades lícitas.</li>

          </ul>
        </p>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>
